import axios from '@/apis/axios';

class Currency 
{
    static async all()
    {
        const response = await axios.get('api/currencies');

        return response.data.data;
    }

    static async getDefaultCurrency()
    {
        const response = await axios.get('api/default-currency');

        return response.data.data;
    }
}
export default Currency;